/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Blocked_Not_ActiveInputs */

const fr_membership_freeze_blocked_not_active = /** @type {(inputs: Membership_Freeze_Blocked_Not_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause indisponible : votre abonnement n'est pas actif.`)
};

/**

* @param {Membership_Freeze_Blocked_Not_ActiveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_blocked_not_active = /** @type {((inputs?: Membership_Freeze_Blocked_Not_ActiveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Blocked_Not_ActiveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_blocked_not_active(inputs)
});